export const WAREHOUSE_TEST_ID = 'AddressTypeWarehouse';
